module.exports = "<div *ngIf=\"isLoaderVisible\">\n  <div class=\"blockUI blockOverlay\">\n  </div>\n  <div id=\"loader-container\">\n    <div class=\"spinner\"></div>\n  </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/common/loader/loader.component.html
// module id = 358
// module chunks = 1